














import {Vue, Component} from 'vue-property-decorator';

@Component
export default class SignIn extends Vue {
    signIn() {
        this.$store.dispatch('signIn');
    }
}
